module.exports = "/_next/static/images/GearedM-853dd240b27aea396b4795380e70d3b2.png";